import { Sparkles } from 'lucide-react';

/**
 * Wave 21+: バージョン番号は vite.config.ts の define で package.json の
 * version から自動埋め込み。デプロイごとに npm の version フィールドを
 * 上げれば UI にも反映される (手動ハードコード不要)。
 */
export function Header(): JSX.Element {
  return (
    <header className="border-silver-primary bg-bg-primary border-b">
      <div className="mx-auto flex h-12 max-w-6xl items-center gap-3 px-6">
        <Sparkles className="text-accent-primary h-4 w-4" strokeWidth={1.5} aria-hidden />
        <h1 className="text-text-primary text-sm font-semibold tracking-tight">
          HI-TOP Photo Prep
        </h1>
        <span className="bg-bg-secondary text-text-secondary ml-2 rounded-full px-2 py-0.5 text-[10px] font-medium tracking-wide uppercase">
          v{__APP_VERSION__}
        </span>
        <div className="text-text-tertiary ml-auto text-[11px]">
          カーセンサー掲載用 車両写真一括処理
        </div>
      </div>
    </header>
  );
}
